<mat-tab-group
	*ngIf="!hideEmailPasswordLogin; else idSelect"
	[attr.mat-stretch-tabs]="true"
	[dynamicHeight]="false"
	[@.disabled]="true"
	[selectedIndex]="selectedTabIndex"
>
	<mat-tab test-id="dga-id-select-tab">
		<ng-template mat-tab-label>
			<span data-test-id="mit-id-tab">{{ idTabText }}</span>
		</ng-template>
		<ng-template matTabContent>
			<obg-m-id-select-component></obg-m-id-select-component>
		</ng-template>
	</mat-tab>
	<mat-tab>
		<ng-template mat-tab-label>
			<span [innerHTML]="'login.type.email-password' | translate"></span>
		</ng-template>
		<ng-template matTabContent>
			<obg-m-generic-login-container
				[autoFocus]="autoFocus"
				[errorsInAlert]="errorsInAlert"
				[allLinksExternal]="allLinksExternal"
				(busy)="busy.emit($event)"
			>
			</obg-m-generic-login-container>
		</ng-template>
	</mat-tab>
</mat-tab-group>
<ng-template #idSelect>
	<obg-m-id-select-component></obg-m-id-select-component>
</ng-template>
